'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
exports.truncateAddress = void 0;
var _core = require('@sei-js/core');
var truncateAddress = (exports.truncateAddress = function truncateAddress(address) {
	if (!(0, _core.isValidSeiAddress)(address)) {
		return address;
	}
	return ''.concat(address.slice(0, 3), '....').concat(address.slice(address.length - 5));
});
//# sourceMappingURL=address.js.map
